var bottomArrow = '_1f9yud12';
var container = '_1f9yud11 _14wijgr9';
var content = '_1f9yud14';
var hasIconLead = '_1f9yud13';
var icon = '_1f9yud18';
var iconLead = '_1f9yud15';
var iconTriggerButton = '_1f9yud17';
var shortcutText = '_1f9yud1a _14wijgr9';
var text = '_1f9yud16 _14wijgr9';
var trail = '_1f9yud19';

export { bottomArrow, container, content, hasIconLead, icon, iconLead, iconTriggerButton, shortcutText, text, trail };
//# sourceMappingURL=toggle-tip.css.js.map
